import { HStack, Link, Button } from '@chakra-ui/react'
import { Link as ReactLink } from 'react-router-dom'
import React from 'react'

const FinalPanel = () => {
    return (
        <HStack w="full" justify="center">
            <Link to="/" as={ReactLink}>
                <Button fontSize="md" variant="link" mt={4}>
                    กลับหน้าหลัก
                </Button>
            </Link>
        </HStack>
    )
}

export default FinalPanel
